<template>
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable " role="document">
        <div class="modal-content">
            <div class="modal-header p-4">
                <modal-close />
            </div>
            <div class="modal-body p-4 ">
                <slot name="content">
                    <img :src="args.urls.big" alt="">
                </slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'GenericModalComponent',
    computed: {
        args() {
            return this.$store.getters.modalState.args
        }
    }
}
</script>

<style scoped>
.modal-dialog {
  max-width: 100%;
  margin: 0;
  max-height: 100%;
  padding: 0;
}

.modal-content {
  border-radius: 0;
}
.modal-body img{
    max-width: 100%
    }
</style>

<style lang="scss">
.full-screen{
    .modal-lg{
        max-width: 94%;
    }
    .modal-header{
        border:none
    }
}</style>